
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34007',
  depVersions: {
  "documents-public-ui": "static-1.34007",
  "client-types": "static-1.446",
  "documents-lib": "static-1.34012",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1942",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4841",
  "highcharts": "static-8.99",
  "hs-promise-utils": "static-1.5408",
  "hs-test-utils": "static-1.7820",
  "hub-http": "static-1.6035",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11247",
  "I18n": "static-7.1574",
  "jasmine-immutable": "static-1.2833",
  "jasmine-runner": "static-1.6287",
  "lodash": "static-1.3",
  "quartz": "static-1.6753",
  "react": "static-7.180",
  "react-dlb": "static-1.73",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.67",
  "react-rhumb": "static-1.16464",
  "reporting-data": "static-1.66581",
  "reporting-testing-lib": "static-1.8514",
  "reporting-visualizations": "static-1.58657",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4580",
  "webpack-env": "static-1.54",
  "atom": "static-1.4884",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2302",
  "classnames": "static-2.10",
  "cssUtils": "static-1.736",
  "customer-data-filters-ui": "static-1.38951",
  "customer-data-objects": "static-1.7464",
  "customer-data-property-utils": "static-1.7892",
  "data-fetching-client": "static-1.9492",
  "enviro": "static-4.405",
  "FireAlarmUi": "static-1.4343",
  "flux-actions": "static-1.310",
  "FormsCommonComponents": "static-1.85318",
  "FormUrlGenerator": "static-2.4544",
  "foundations-components": "static-1.7549",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3957",
  "HubStyle": "static-2.11555",
  "icons": "static-2.623",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6975",
  "metrics-js": "static-1.9436",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.367",
  "property-description-translator": "static-1.3673",
  "property-translator": "static-1.5227",
  "quartz-config": "static-1.531",
  "quartz-core": "static-1.5972",
  "quick-fetch": "static-1.3749",
  "raven": "static-3.5725",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5187",
  "react-virtualized": "static-2.94",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7975",
  "reference-resolvers-lite": "static-1.7909",
  "report-customization-components": "static-1.12541",
  "reporting-enablement": "static-1.22117",
  "reporting-reports": "static-1.66259",
  "reporting-snowflake": "static-1.55199",
  "reporting-ui-components": "static-2.63852",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4449",
  "sales-content-partitioning": "static-1.8750",
  "SalesContentIndexUI": "static-3.8925",
  "sanitize": "static-1.4289",
  "sanitize-text": "static-1.7956",
  "self-service-api": "static-1.10051",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1567",
  "signup-constants": "static-1.18435",
  "signup-ui-lego-core": "static-1.20445",
  "signup-ui-url-generator": "static-2.7858",
  "styled-components": "static-2.85",
  "StyleGuideUI": "static-3.484",
  "superstore": "static-1.4585",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10809",
  "ui-addon-i18n": "static-1.10955",
  "ui-addon-react-router-dom": "static-1.9361",
  "ui-addon-upgrades": "static-9.17680",
  "ui-asset-management-lib": "static-1.10729",
  "ui-images": "static-2.1096",
  "UIComponents": "static-3.8194",
  "usage-tracker": "static-1.7149",
  "usage-tracker-container": "static-1.7139",
  "usage-tracker-core": "static-1.6999",
  "usage-tracker-public": "static-1.6960",
  "viral-links-lib": "static-1.6850",
  "hs-promise-rejection-tracking": "static-1.5387",
  "raven-hubspot": "static-1.6032",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3243",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3030",
  "quartz-webpack": "static-1.2977",
  "ai-components-ui-library": "static-1.8380",
  "amplitude-session-replay-browser": "static-1.55",
  "foundations-assets": "static-1.4651",
  "foundations-theming": "static-1.4226",
  "quartz-auth": "static-1.428",
  "ui-business-units-lib": "static-1.8844",
  "usage-tracker-session-replay": "static-1.4835",
  "foundations-theming-base": "static-1.3211",
  "HeadJS": "static-2.713",
  "framer-motion": "static-1.67",
  "hs-test-utils-bend-plugin": "static-1.2931",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4141",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7739",
  "graphql": "static-1.77",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3431",
  "persist-promise": "static-1.3523",
  "reporting-client-types": "static-1.2387",
  "foundations-components-legacy": "static-1.574",
  "hs-story-utils": "static-1.9242",
  "react-flip-move": "static-1.65",
  "hub-http-shared-msw-handlers": "static-1.9507",
  "hubspotter-http": "static-1.4492",
  "sassPrefix": "static-1.152",
  "conversations-skeleton-state": "static-1.7062",
  "crm-message-bus": "static-1.42405",
  "customer-data-filters-ui-msw-helpers": "static-1.21386",
  "customer-data-objects-ui-components": "static-1.12824",
  "customer-data-reference-ui-components": "static-1.12961",
  "customer-data-ui-utilities": "static-1.9638",
  "framework-builder-read-service-client": "static-1.3847",
  "framework-data-schema-quick-fetch": "static-1.6593",
  "framework-data-schema-resolvers": "static-1.6688",
  "inbound-db-properties-service-client": "static-1.3689",
  "multi-account-reference-resolvers": "static-1.788",
  "onboarding-tours": "static-1.16280",
  "reporting-datasets-permissions-lib": "static-1.13091",
  "ui-addon-teams": "static-1.21262",
  "apollo-stack-hubspot": "static-3.81",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67661",
  "customer-data-properties": "static-1.50837",
  "forms-ai-lib": "static-1.4028",
  "forms-utils-lib": "static-1.12193",
  "foundations-components-test-utils": "static-1.5032",
  "react-dnd-compat": "static-1.4435",
  "react-tinymce": "static-1.54657",
  "tinymce-config": "static-2.53783",
  "ui-gdpr-components": "static-1.10162",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3818",
  "floating-ui": "static-1.51",
  "react-aria": "static-1.61",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1246",
  "ui-fonts": "static-1.509",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.798",
  "mobile-manifest-mixins": "static-1.486",
  "module-federation": "static-1.18",
  "quartz-head": "static-1.418",
  "quartz-i18n": "static-1.428",
  "quartz-routing": "static-1.183",
  "quartz-test": "static-1.428",
  "quartz-tracking": "static-1.132",
  "batch-promise": "static-1.1366",
  "external-options-client-types": "static-1.3998",
  "react-colorpicker": "static-2.10024",
  "copilot-toolkit": "static-1.10568",
  "data-quality-ui-library": "static-1.12351",
  "html-to-image": "static-1.49",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40691",
  "reporting-insights-lib": "static-1.1201",
  "reporting-plugins": "static-1.10003",
  "ui-addon-draggable-compat": "static-2.4068",
  "ui-addon-opt": "static-4.8199",
  "ui-shepherd-react": "static-3.9962",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24764",
  "hubspot-apollo-client": "static-1.4696",
  "sales-templates-service-types-lib": "static-1.4005",
  "merchandise-lib": "static-1.259",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5500",
  "salesImages": "static-1.521",
  "ts-schema": "static-1.3918",
  "timezone-utils": "static-2.5059",
  "bender-build-tools": "static-1.2956",
  "chatspot-core": "static-1.20382",
  "chirp-fetch": "static-1.1697",
  "bend-plugin-foundations-theming": "static-1.2709",
  "stylex": "static-1.27",
  "hubspotter-http-shared-msw-handlers": "static-1.9505",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3637",
  "crm-pipelines-api-client-types": "static-1.3978",
  "multi-currency-client-types": "static-1.3531",
  "getting-started-shared-tasks": "static-1.17923",
  "growth-data-modal": "static-1.5173",
  "growth-onboarding-confetti": "static-1.2887",
  "growth-onboarding-next-action-utils": "static-1.1325",
  "navigation-components": "static-1.17311",
  "onboarding-tours-client": "static-1.4494",
  "onboarding-tours-utils": "static-1.346",
  "ui-shepherd-tracker": "static-1.7343",
  "ui-universal-auth": "static-1.8718",
  "user-context": "static-1.4914",
  "cms-field-types": "static-1.4621",
  "content-icons-ui": "static-1.2158",
  "integrations-lib": "static-1.15458",
  "calling-global-api": "static-1.63717",
  "calling-internal-common": "static-1.31109",
  "calling-lifecycle-internal": "static-1.65099",
  "calling-lifecycle-messages": "static-1.57393",
  "commerce-products-lib": "static-1.8897",
  "crm-links": "static-1.6081",
  "file-manager-components": "static-1.22928",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.493",
  "inbounddb-objects-service-types": "static-1.4062",
  "meetings-icalendar-utils-lib": "static-1.448",
  "object-builder-ui-client": "static-1.48023",
  "pipeline-validation-client-types": "static-1.3800",
  "property-value-citations": "static-1.1451",
  "pulse": "static-1.328",
  "smart-property-lib": "static-1.5962",
  "tiered-pricing": "static-1.849",
  "ui-addon-iframeable": "static-1.8859",
  "final-form": "static-1.65",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19493",
  "tinymce-themes": "static-1.55753",
  "data-token-picker": "static-1.16064",
  "hub-http-contrib": "static-1.2858",
  "interframe": "static-3.4604",
  "tinymce-data": "static-1.39868",
  "tinymce-plugins": "static-1.56897",
  "ui-addon-sales-email": "static-1.5028",
  "magpie-lib": "static-1.5409",
  "magpie-types": "static-1.4869",
  "simple-logging-lib": "static-1.2865",
  "content-assistance-lib": "static-1.7469",
  "dashboard-lib": "static-1.80678",
  "ExportDialog": "static-6.10202",
  "hubspot-prosemirror": "static-1.17642",
  "hubspot-prosemirror-plugins": "static-1.17634",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8507",
  "campaign-roi-lib": "static-1.8313",
  "feedback-loader": "static-1.28881",
  "onboarding-scopes": "static-1.6278",
  "apollo-link-hub-http": "static-2.4464",
  "hubspot-apollo-cache": "static-1.155",
  "growth-monetization-service-types": "static-1.4328",
  "nav-client-types": "static-1.2172",
  "purchase-motions-api": "static-1.5503",
  "trials-service-types": "static-1.3729",
  "growth-onboarding-next-action-components": "static-1.1353",
  "user-context-client": "static-1.4477",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.540",
  "unified-auth-core-lib": "static-1.513",
  "getting-started-shared-tasks-store": "static-1.17041",
  "integrations-error-boundary-lib": "static-1.12873",
  "integrations-tracking-lib": "static-1.5403",
  "native-integrations-shared-strings": "static-1.7603",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10186",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31115",
  "shared-worker-versioning": "static-1.10853",
  "calling-usage-tracker": "static-1.6355",
  "voice-sms-access-library": "static-1.285",
  "customer-data-tracking": "static-1.6697",
  "commerce-permissions": "static-1.573",
  "products-iframe-lib": "static-1.7354",
  "products-ui-components-shared-msw-handlers": "static-1.9889",
  "location-customization-utils-lib": "static-1.8602",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3970",
  "video-components-external": "static-1.10608",
  "video-data-lib": "static-1.34266",
  "directed-graph": "static-1.751",
  "event-emitter": "static-1.762",
  "breeze-intelligence-kit": "static-1.5340",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9590",
  "fsm": "static-1.3546",
  "policy-lib": "static-1.6601",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9653",
  "navigation-messaging": "static-1.6638",
  "FileManagerLib": "static-1.38568",
  "NamespacedHubStyle": "static-2.8910",
  "FileManagerCore": "static-1.38427",
  "codemirror": "static-5.90",
  "layout-dnd-components": "static-1.12058",
  "layout-dnd-utils": "static-1.11033",
  "react-codemirror": "static-1.10442",
  "ui-addon-emoji-picker": "static-1.9703",
  "ui-brand-identity-lib": "static-1.13950",
  "ui-addon-video-player": "static-1.8511",
  "ui-coaching-tips": "static-1.27979",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8383",
  "payment-link-components": "static-1.22975",
  "EmailSignatureEditor": "static-1.23938",
  "eligibility-engine-service-types": "static-1.3010",
  "universal-page-editor-lib": "static-1.2814",
  "calling-orchestration-schema": "static-1.35062",
  "sales-views-client-types": "static-1.4102",
  "crm-record-cards-service-types": "static-1.3460",
  "content-media-composition-data-lib": "static-1.11507",
  "content-media-compositions": "static-2.15514",
  "media-bridge-lib": "static-1.18587",
  "trellis-story-utils": "static-1.4336",
  "storybook-react": "static-1.28",
  "audio-components": "static-1.5632",
  "FileManagerImages": "static-1.36079",
  "video-components": "static-1.12611",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4347",
  "video-embed": "static-1.35100",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67736",
  "layout-data-lib": "static-1.9358",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6398",
  "commerce-tours-lib": "static-1.5739",
  "growth-onboarding-reliability": "static-1.4901",
  "sales-checkout-service-client": "static-1.3483",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21329",
  "sales-email-signature-service-client": "static-1.3659",
  "hls.js": "static-1.34",
  "social-insights-client-types": "static-1.21391",
  "outpost": "static-1.4018",
  "advanced-menus-core": "static-1.14834",
  "advanced-menus-lib": "static-1.11806",
  "ui-memberships-settings-lib": "static-1.33464",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14833",
  "simple-menus-lib": "static-1.16350"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34007",
  "client-types": "/client-types/static-1.446",
  "documents-lib": "/documents-lib/static-1.34012",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1942",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4841",
  "highcharts": "/highcharts/static-8.99",
  "hs-promise-utils": "/hs-promise-utils/static-1.5408",
  "hs-test-utils": "/hs-test-utils/static-1.7820",
  "hub-http": "/hub-http/static-1.6035",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11247",
  "I18n": "/I18n/static-7.1574",
  "jasmine-immutable": "/jasmine-immutable/static-1.2833",
  "jasmine-runner": "/jasmine-runner/static-1.6287",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6753",
  "react": "/react/static-7.180",
  "react-dlb": "/react-dlb/static-1.73",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.67",
  "react-rhumb": "/react-rhumb/static-1.16464",
  "reporting-data": "/reporting-data/static-1.66581",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8514",
  "reporting-visualizations": "/reporting-visualizations/static-1.58657",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4580",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4884",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2302",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.736",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38951",
  "customer-data-objects": "/customer-data-objects/static-1.7464",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7892",
  "data-fetching-client": "/data-fetching-client/static-1.9492",
  "enviro": "/enviro/static-4.405",
  "FireAlarmUi": "/FireAlarmUi/static-1.4343",
  "flux-actions": "/flux-actions/static-1.310",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85318",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4544",
  "foundations-components": "/foundations-components/static-1.7549",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyle": "/HubStyle/static-2.11555",
  "icons": "/icons/static-2.623",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6975",
  "metrics-js": "/metrics-js/static-1.9436",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "property-description-translator": "/property-description-translator/static-1.3673",
  "property-translator": "/property-translator/static-1.5227",
  "quartz-config": "/quartz-config/static-1.531",
  "quartz-core": "/quartz-core/static-1.5972",
  "quick-fetch": "/quick-fetch/static-1.3749",
  "raven": "/raven/static-3.5725",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5187",
  "react-virtualized": "/react-virtualized/static-2.94",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7975",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7909",
  "report-customization-components": "/report-customization-components/static-1.12541",
  "reporting-enablement": "/reporting-enablement/static-1.22117",
  "reporting-reports": "/reporting-reports/static-1.66259",
  "reporting-snowflake": "/reporting-snowflake/static-1.55199",
  "reporting-ui-components": "/reporting-ui-components/static-2.63852",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4449",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8750",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8925",
  "sanitize": "/sanitize/static-1.4289",
  "sanitize-text": "/sanitize-text/static-1.7956",
  "self-service-api": "/self-service-api/static-1.10051",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1567",
  "signup-constants": "/signup-constants/static-1.18435",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20445",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7858",
  "styled-components": "/styled-components/static-2.85",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "superstore": "/superstore/static-1.4585",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10809",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10955",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9361",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17680",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10729",
  "ui-images": "/ui-images/static-2.1096",
  "UIComponents": "/UIComponents/static-3.8194",
  "usage-tracker": "/usage-tracker/static-1.7149",
  "usage-tracker-container": "/usage-tracker-container/static-1.7139",
  "usage-tracker-core": "/usage-tracker-core/static-1.6999",
  "usage-tracker-public": "/usage-tracker-public/static-1.6960",
  "viral-links-lib": "/viral-links-lib/static-1.6850",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3243",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3030",
  "quartz-webpack": "/quartz-webpack/static-1.2977",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8380",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4651",
  "foundations-theming": "/foundations-theming/static-1.4226",
  "quartz-auth": "/quartz-auth/static-1.428",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8844",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4835",
  "foundations-theming-base": "/foundations-theming-base/static-1.3211",
  "HeadJS": "/HeadJS/static-2.713",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2931",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4141",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7739",
  "graphql": "/graphql/static-1.77",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3431",
  "persist-promise": "/persist-promise/static-1.3523",
  "reporting-client-types": "/reporting-client-types/static-1.2387",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.574",
  "hs-story-utils": "/hs-story-utils/static-1.9242",
  "react-flip-move": "/react-flip-move/static-1.65",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9507",
  "hubspotter-http": "/hubspotter-http/static-1.4492",
  "sassPrefix": "/sassPrefix/static-1.152",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7062",
  "crm-message-bus": "/crm-message-bus/static-1.42405",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21386",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12824",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12961",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9638",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3847",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6593",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6688",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3689",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.788",
  "onboarding-tours": "/onboarding-tours/static-1.16280",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13091",
  "ui-addon-teams": "/ui-addon-teams/static-1.21262",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.81",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67661",
  "customer-data-properties": "/customer-data-properties/static-1.50837",
  "forms-ai-lib": "/forms-ai-lib/static-1.4028",
  "forms-utils-lib": "/forms-utils-lib/static-1.12193",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5032",
  "react-dnd-compat": "/react-dnd-compat/static-1.4435",
  "react-tinymce": "/react-tinymce/static-1.54657",
  "tinymce-config": "/tinymce-config/static-2.53783",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10162",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3818",
  "floating-ui": "/floating-ui/static-1.51",
  "react-aria": "/react-aria/static-1.61",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1246",
  "ui-fonts": "/ui-fonts/static-1.509",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.798",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.486",
  "module-federation": "/module-federation/static-1.18",
  "quartz-head": "/quartz-head/static-1.418",
  "quartz-i18n": "/quartz-i18n/static-1.428",
  "quartz-routing": "/quartz-routing/static-1.183",
  "quartz-test": "/quartz-test/static-1.428",
  "quartz-tracking": "/quartz-tracking/static-1.132",
  "batch-promise": "/batch-promise/static-1.1366",
  "external-options-client-types": "/external-options-client-types/static-1.3998",
  "react-colorpicker": "/react-colorpicker/static-2.10024",
  "copilot-toolkit": "/copilot-toolkit/static-1.10568",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12351",
  "html-to-image": "/html-to-image/static-1.49",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40691",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1201",
  "reporting-plugins": "/reporting-plugins/static-1.10003",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4068",
  "ui-addon-opt": "/ui-addon-opt/static-4.8199",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9962",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24764",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4696",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4005",
  "merchandise-lib": "/merchandise-lib/static-1.259",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5500",
  "salesImages": "/salesImages/static-1.521",
  "ts-schema": "/ts-schema/static-1.3918",
  "timezone-utils": "/timezone-utils/static-2.5059",
  "bender-build-tools": "/bender-build-tools/static-1.2956",
  "chatspot-core": "/chatspot-core/static-1.20382",
  "chirp-fetch": "/chirp-fetch/static-1.1697",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2709",
  "stylex": "/stylex/static-1.27",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9505",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3637",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3978",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3531",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17923",
  "growth-data-modal": "/growth-data-modal/static-1.5173",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2887",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1325",
  "navigation-components": "/navigation-components/static-1.17311",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4494",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.346",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7343",
  "ui-universal-auth": "/ui-universal-auth/static-1.8718",
  "user-context": "/user-context/static-1.4914",
  "cms-field-types": "/cms-field-types/static-1.4621",
  "content-icons-ui": "/content-icons-ui/static-1.2158",
  "integrations-lib": "/integrations-lib/static-1.15458",
  "calling-global-api": "/calling-global-api/static-1.63717",
  "calling-internal-common": "/calling-internal-common/static-1.31109",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65099",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57393",
  "commerce-products-lib": "/commerce-products-lib/static-1.8897",
  "crm-links": "/crm-links/static-1.6081",
  "file-manager-components": "/file-manager-components/static-1.22928",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.493",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4062",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.448",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48023",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3800",
  "property-value-citations": "/property-value-citations/static-1.1451",
  "pulse": "/pulse/static-1.328",
  "smart-property-lib": "/smart-property-lib/static-1.5962",
  "tiered-pricing": "/tiered-pricing/static-1.849",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8859",
  "final-form": "/final-form/static-1.65",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19493",
  "tinymce-themes": "/tinymce-themes/static-1.55753",
  "data-token-picker": "/data-token-picker/static-1.16064",
  "hub-http-contrib": "/hub-http-contrib/static-1.2858",
  "interframe": "/interframe/static-3.4604",
  "tinymce-data": "/tinymce-data/static-1.39868",
  "tinymce-plugins": "/tinymce-plugins/static-1.56897",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5028",
  "magpie-lib": "/magpie-lib/static-1.5409",
  "magpie-types": "/magpie-types/static-1.4869",
  "simple-logging-lib": "/simple-logging-lib/static-1.2865",
  "content-assistance-lib": "/content-assistance-lib/static-1.7469",
  "dashboard-lib": "/dashboard-lib/static-1.80678",
  "ExportDialog": "/ExportDialog/static-6.10202",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17642",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17634",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8507",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8313",
  "feedback-loader": "/feedback-loader/static-1.28881",
  "onboarding-scopes": "/onboarding-scopes/static-1.6278",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4464",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.155",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4328",
  "nav-client-types": "/nav-client-types/static-1.2172",
  "purchase-motions-api": "/purchase-motions-api/static-1.5503",
  "trials-service-types": "/trials-service-types/static-1.3729",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1353",
  "user-context-client": "/user-context-client/static-1.4477",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.540",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.513",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17041",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12873",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5403",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7603",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10186",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31115",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10853",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6355",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.285",
  "customer-data-tracking": "/customer-data-tracking/static-1.6697",
  "commerce-permissions": "/commerce-permissions/static-1.573",
  "products-iframe-lib": "/products-iframe-lib/static-1.7354",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9889",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8602",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3970",
  "video-components-external": "/video-components-external/static-1.10608",
  "video-data-lib": "/video-data-lib/static-1.34266",
  "directed-graph": "/directed-graph/static-1.751",
  "event-emitter": "/event-emitter/static-1.762",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5340",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9590",
  "fsm": "/fsm/static-1.3546",
  "policy-lib": "/policy-lib/static-1.6601",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9653",
  "navigation-messaging": "/navigation-messaging/static-1.6638",
  "FileManagerLib": "/FileManagerLib/static-1.38568",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8910",
  "FileManagerCore": "/FileManagerCore/static-1.38427",
  "codemirror": "/codemirror/static-5.90",
  "layout-dnd-components": "/layout-dnd-components/static-1.12058",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11033",
  "react-codemirror": "/react-codemirror/static-1.10442",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9703",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13950",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8511",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27979",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8383",
  "payment-link-components": "/payment-link-components/static-1.22975",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23938",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3010",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2814",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35062",
  "sales-views-client-types": "/sales-views-client-types/static-1.4102",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3460",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11507",
  "content-media-compositions": "/content-media-compositions/static-2.15514",
  "media-bridge-lib": "/media-bridge-lib/static-1.18587",
  "trellis-story-utils": "/trellis-story-utils/static-1.4336",
  "storybook-react": "/storybook-react/static-1.28",
  "audio-components": "/audio-components/static-1.5632",
  "FileManagerImages": "/FileManagerImages/static-1.36079",
  "video-components": "/video-components/static-1.12611",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4347",
  "video-embed": "/video-embed/static-1.35100",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67736",
  "layout-data-lib": "/layout-data-lib/static-1.9358",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6398",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5739",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4901",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3483",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21329",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3659",
  "hls.js": "/hls.js/static-1.34",
  "social-insights-client-types": "/social-insights-client-types/static-1.21391",
  "outpost": "/outpost/static-1.4018",
  "advanced-menus-core": "/advanced-menus-core/static-1.14834",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11806",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33464",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14833",
  "simple-menus-lib": "/simple-menus-lib/static-1.16350"
}
};
